module.exports = __webpack_public_path__ + "fr-env.svg";